
export class PercentageParameter {

    constructor($scope, $log) {
        this.$scope = $scope;
        this.$log = $log;
        $log.debug('Mounting PercentegeParameter component');
    }

    $onInit = () => {
        this.$scope.parameter = this.parameter;
        this.$log.debug('Mounted PercentegeParameter component')
    }

}

const PERCENTAGE_PARAMETER_CONTROLLER = ['$scope', '$log', PercentageParameter];

export const PERCENTAGE_PARAMETER_COMPONENT = {
    template: require('./percentegeParameter.html'),
    controller: PERCENTAGE_PARAMETER_CONTROLLER,
    bindings: {
        parameter: '='
    }
};